/** A user-typed web address as an absolute http(s) URL.
 *
 *  Editors accept `example.com/menu` as readily as `https://example.com/menu`
 *  (the gallery's video_url only asks for "something with a dot"). Handing a
 *  scheme-less value to `act.external` would make the popover render a
 *  ROUTER link to `/example.com/menu` — the SPA would navigate to a 404 —
 *  so every external action built from an editable value goes through here.
 *  Values that already carry a scheme (`http:`, `https:`, `mailto:`, …) pass
 *  untouched. */
export function externalUrl(value: string): string {
  const v = value.trim();
  return /^[a-z][a-z0-9+.-]*:/i.test(v) ? v : `https://${v}`;
}

/** `true` when a user-typed value can be opened as a web address: it either
 *  carries a scheme, or has a dot and no whitespace — the same "something with
 *  a dot" shape the editors themselves validate. Empty (or clearly-not-a-URL)
 *  values yield no external action at all, so a blank field never grows a dead
 *  trigger. */
export function looksLikeUrl(value: string | null | undefined): value is string {
  const v = value?.trim() ?? '';
  if (v === '' || /\s/.test(v)) return false;
  return /^[a-z][a-z0-9+.-]*:/i.test(v) || /\.[^.\s]/.test(v);
}
